<section class="flex statistics-adm">

   <main style="width: 100%">
      <div class="d-flex justify-flex-end">
         <div class="dropdown">
            <button class="dropbtn">
               <i class="fa fa-download"></i> {{ 'general.export_data' | translate }}
            </button>
            <div class="dropdown-content">
               <a (click)="exportToExcel()">{{ 'general.export_as_excel' | translate }}</a>
               <a (click)="exportToPDF()">{{ 'general.export_as_pdf' | translate }}</a>
               <a (click)="exportToCSV()">{{ 'general.export_as_csv' | translate }}</a>
            </div>
         </div>
      </div>
      <div #contentToCapture>
         <h2>{{ 'new_entries.institutional_metrics' | translate }}</h2>
         <div class="overview white border shadow">

            <section class="institutional-metrics">
               <div class="metrics-grid">
                  <div class="metric-card">
                     <img src="../../../../assets/images/newIcons/Subjects.png" alt="Subjects" class="icon" />
                     <div class="metric-info">
                        <div class="label">{{ 'new_entries.subjects' | translate }}</div>
                        <div class="value">{{ institutionData?.nrOfSubjects || 0 }}</div>
                     </div>
                  </div>
                  <div class="metric-card">
                     <img src="../../../../assets/images/newIcons/Assignments.png" alt="Assignments" class="icon" />
                     <div class="metric-info">
                        <div class="label">{{ 'new_entries.assignments' | translate }}</div>
                        <div class="value">{{ institutionData?.nrOfAssignments || 0 }}</div>
                     </div>
                  </div>
                  <div class="metric-card">
                     <img src="../../../../assets/images/newIcons/Educator.png" alt="Educator" class="icon" />
                     <div class="metric-info">
                        <div class="label">{{ 'new_entries.educator' | translate }}</div>
                        <div class="value">{{ institutionData?.nrOfProfessors || 0 }}</div>
                     </div>
                  </div>

                  <div class="metric-card">
                     <img src="../../../../assets/images/newIcons/Students.png" alt="Students" class="icon" />
                     <div class="metric-info">
                        <div class="label">{{ 'new_entries.students' | translate }}</div>
                        <div class="value">{{ institutionData?.nrOfStudents || 0 }}</div>
                     </div>
                  </div>
                  <div class="metric-card">
                     <img src="../../../../assets/images/newIcons/StudentSubmissions.png" alt="Student submissions"
                        class="icon" />
                     <div class="metric-info">
                        <div class="label">{{ 'new_entries.student_submissions' | translate }}</div>
                        <div class="value">{{ institutionData?.nrOfStudentSubmissions || 0 }}</div>
                     </div>
                  </div>
                  <div class="metric-card">
                     <img src="../../../../assets/images/newIcons/37.Students_Precheck.png" alt="Students precheck"
                        class="icon" />
                     <div class="metric-info">
                        <div class="label">{{ 'new_entries.students_precheck' | translate }}</div>
                        <div class="value">{{ institutionData?.nrOfStudentPreCheckSubmissions || 0 }}</div>
                     </div>
                  </div>
                  <div class="metric-card">
                     <img src="../../../../assets/images/newIcons/36.EducatorSubmissions.png"
                        alt="Educators submissions" class="icon" />
                     <div class="metric-info">
                        <div class="label">{{ 'new_entries.educators_submissions' | translate }}</div>
                        <div class="value">{{ institutionData?.nrOfProfessorSubmissions || 0 }}</div>
                     </div>
                  </div>
                  <div class="metric-card">
                     <img src="../../../../assets/images/newIcons/38.Deleted_Assignments.png" alt="Deleted submissions"
                        class="icon" />
                     <div class="metric-info">
                        <div class="label">{{ 'new_entries.deleted_submissions' | translate }}</div>
                        <div class="value">{{ institutionData?.deletedSubmissions || 0 }}</div>
                     </div>
                  </div>
               </div>
            </section>
         </div>



         <!-- Student Submissions – Originality Risk Trends Section -->
         <section class="risk-trends-section">
            <div class="risk-trends-header-row">
               <div>
                  <h2 class="risk-trends-main-title">
                     {{ selectedSubmissionType === 'student' ? ('new_entries.student_submissions' | translate) :
                     ('new_entries.educators_submissions' | translate) }} – {{
                     'new_entries.student_submissions_originality_risk_trends' | translate }}
                  </h2>
                  <div class="risk-trends-main-subtitle">
                     {{ 'new_entries.monthly_distribution_of_submissions_by_originality_risk_level' | translate }}
                  </div>
               </div>
               <div class="risk-trends-controls">
                  <select class="risk-dropdown" [(ngModel)]="selectedSubmissionType"
                     (change)="onSubmissionTypeChange($event)">
                     <option value="student">{{ 'new_entries.student_submissions' | translate }}</option>
                     <option value="educator">{{ 'new_entries.educators_submissions' | translate }}</option>
                  </select>
                  <select class="risk-year-selector" [(ngModel)]="selectedYear" (change)="onYearChange($event)">
                     <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
                  </select>
               </div>
            </div>
            <app-risk-trends-graph [year]="selectedYear"
               [submissionType]="selectedSubmissionType"></app-risk-trends-graph>
         </section>

         <h2 class="risk-trends-main-title">{{ 'new_entries.originality_report_insights' | translate }}</h2>
         <div class="risk-trends-main-subtitle">
            {{ 'new_entries.a_comprehensive_view_of_submission_patterns' | translate }}
         </div>

         <div class="overview white border shadow">
            <div class=""
               style="font-size: 1.2rem; font-weight: 600; color: #222; margin-left: 24px; padding-top: 10px;">
               {{ 'new_entries.originality_score_breakdown' | translate }}</div>
            <div class="risk-trends-main-subtitle" style="margin-left: 24px">
               {{ 'new_entries.submission_counts_grouped_by_originality_score_ranges' | translate }}
            </div>
            <div class="metrics-grid">
               <div class="metric-card">
                  <img src="../../../../assets/images/newIcons/highRisk.png" alt="High Risk" class="icon" />
                  <div class="metric-info">
                     <div class="label">{{ getHighRiskLabel() }}</div>
                     <div class="value">{{ filteredData?.nrOfHighSimilaritySubmissions || 0 }}</div>
                  </div>
               </div>
               <div class="metric-card">
                  <img src="../../../../assets/images/newIcons/mediumRisk.png" alt="Medium Risk" class="icon" />
                  <div class="metric-info">
                     <div class="label">{{ getMediumRiskLabel() }}</div>
                     <div class="value">{{ filteredData?.nrOfMediumSimilaritySubmissions || 0 }}</div>
                  </div>
               </div>
               <div class="metric-card">
                  <img src="../../../../assets/images/newIcons/lowRisk.png" alt="Low Risk" class="icon" />
                  <div class="metric-info">
                     <div class="label">{{ getLowRiskLabel() }}</div>
                     <div class="value">{{ filteredData?.nrOfLowSimilaritySubmissions || 0 }}</div>
                  </div>
               </div>
               <div class="metric-card">
                  <img src="../../../../assets/images/newIcons/inProcess.png" alt="In Process" class="icon" />
                  <div class="metric-info">
                     <div class="label">{{ 'new_entries.in_process_submissions' | translate }}</div>
                     <div class="value">{{ filteredData?.inProcessSubmissions || 0 }}</div>
                  </div>
               </div>
            </div>
            <div class="donut-charts-row">
               <app-language-distribution-donut title="{{ 'new_entries.original_language_distribution' | translate }}"
                  [filterType]="selectedSubmissionType"></app-language-distribution-donut>
               <app-language-distribution-donut title="{{ 'new_entries.translated_language_distribution' | translate }}"
                  [isTranslated]="true" [filterType]="selectedSubmissionType"></app-language-distribution-donut>
            </div>

            <div class="ai-charts-row">
               <app-ai-score-distribution [filterType]="selectedSubmissionType"></app-ai-score-distribution>
               <app-manipulation-type-frequency [filterType]="selectedSubmissionType"></app-manipulation-type-frequency>
            </div>

            <div class="ai-charts-row">
               <app-user-registration-trends></app-user-registration-trends>
               <!-- <app-user-registration-trends [filterType]="selectedSubmissionType"></app-user-registration-trends> -->

            </div>
         </div>

      </div>
   </main>
</section>